import Helpers from "../../commons/helpers";
import Strings from "../../constants/strings";

import { Avatar } from "@maysoft/common-component-react";
import { IDataComment, IMenuItem } from "../../commons/interfaces";
import { ILatestComment, IRecordChannel } from "../../containers/channel/useChannel";

export const convertIRecordChannelToItemMenu = (data: {
    language?: string;
    communityId: string;
    resourceCode: string;
    listChannels: IRecordChannel[];

    iconName?: string;
    hidenIcon?: boolean;
    icon?: React.ReactNode;

    screenPathCreate: string;
    screenCreate: React.ReactNode;

    screenPathChild: string;
    screenChild: React.ReactNode;
}) => {
    let textLength = "";
    const listItemMenu: IMenuItem[] = [];

    Strings.setLanguage(data.language || "vi");

    if (data.listChannels.length > 0) {
        data.listChannels.forEach((item) => {
            const iconChild = Helpers.isNullOrEmpty(item.avatarImageUrl) ? null : (
                <Avatar src={item.avatarImageUrl} style={{ width: 30, height: 30 }} />
            );

            listItemMenu.push({
                key: item.id,
                isVisible: true,
                title: item.name,
                screenName: data.screenChild,
                resourceCode: data.resourceCode,
                screenPath: `${data.screenPathChild}?communityId=${data.communityId}&channelId=${item.id}`,
                icon: iconChild,
            });
        });

        textLength = `(${data.listChannels.length})`;
    }

    const newItemMenu: IMenuItem = {
        key: "channel",
        isVisible: true,
        icon: data.icon,
        iconName: data.iconName,
        hidenIcon: data.hidenIcon,
        resourceCode: data.resourceCode,
        title: `${Strings.CHANNEL.TITLE_MENU} ${textLength}`,
        subMenu: [
            {
                key: "create",
                isVisible: true,
                iconName: "add_circle",
                screenName: data.screenCreate,
                resourceCode: data.resourceCode,
                title: Strings.CHANNEL.CREATE_CHANNEL,
                screenPath: `${data.screenPathCreate}?communityId=${data.communityId}&channelId=create`,
            },
            ...listItemMenu,
        ],
    };

    return newItemMenu;
};

export const convertIlatestCommentToDataComment = (latestComment?: ILatestComment | ILatestComment[]) => {
    const dataTemp: IDataComment[] = [];
    if (Array.isArray(latestComment)) {
        latestComment?.forEach((item) => {
            dataTemp.push({
                id: item?.id,
                userComment: {
                    role: undefined,
                    userId: item?.userId,
                    fullName: item?.fullName,
                    userName: item?.userName,
                    avatarId: item?.avatarId,
                    avatarUrl: item?.avatarUrl,
                },
                threadId: item?.threadId,
                channelId: item?.channelId,
                timeComment: item?.createTime,
                discussionValue: item?.discussionValue,
                rating: undefined,
                replyTo: undefined,
                threadGene: undefined,
                totalReact: undefined,
                totalReply: undefined,
                userReactions: undefined,
                listRepliesToComment: undefined,
            });
        });
    } else {
        if (!Helpers.isNullOrEmpty(latestComment)) {
            dataTemp.push({
                id: latestComment?.id,
                userComment: {
                    role: undefined,
                    userId: latestComment?.userId,
                    fullName: latestComment?.fullName,
                    userName: latestComment?.userName,
                    avatarId: latestComment?.avatarId,
                    avatarUrl: latestComment?.avatarUrl,
                },
                threadId: latestComment?.threadId,
                channelId: latestComment?.channelId,
                timeComment: latestComment?.createTime,
                discussionValue: latestComment?.discussionValue,
                userReactions: [],
            });
        }
    }

    return dataTemp;
};

export const convertDataCommentToIlatestComment = (dataComment?: IDataComment | IDataComment[]) => {
    const dataTemp: ILatestComment[] = [];
    if (Array.isArray(dataComment)) {
        dataComment?.forEach((item) => {
            dataTemp.push({
                userType: undefined,
                userId: item.userComment?.userId,
                userName: item.userComment?.userName,
                fullName: item.userComment?.fullName,
                phoneNumber: undefined,
                avatarId: item.userComment?.avatarId,
                avatarUrl: item.userComment?.avatarUrl,
                postId: undefined,
                channelId: item.channelId,
                threadId: item.threadId,
                type: undefined,
                discussionValue: item.discussionValue,
                fileId: undefined,
                fileUrl: undefined,
                id: item.id,
                status: 0,
                createTime: item.timeComment,
                createUser: undefined,
                updateTime: item.timeComment,
                updateUser: undefined,
            });
        });
    } else {
        if (!Helpers.isNullOrEmpty(dataComment)) {
            dataTemp.push({
                userType: undefined,
                userId: dataComment.userComment?.userId,
                userName: dataComment.userComment?.userName,
                fullName: dataComment.userComment?.fullName,
                phoneNumber: undefined,
                avatarId: dataComment.userComment?.avatarId,
                avatarUrl: dataComment.userComment?.avatarUrl,
                postId: undefined,
                channelId: dataComment.channelId,
                threadId: dataComment.threadId,
                type: undefined,
                discussionValue: dataComment.discussionValue,
                fileId: undefined,
                fileUrl: undefined,
                id: dataComment.id,
                status: 0,
                createTime: dataComment.timeComment,
                createUser: undefined,
                updateTime: dataComment.timeComment,
                updateUser: undefined,
            });
        }
    }

    return dataTemp;
};
